/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g;
const APOSTROPHE_REGEX = /['\u2018\u2019`]/g;
const SPECIAL_CHAR_REGEX = /[^\p{L}\p{N}\s]/gu;
const WHITESPACE_REGEX = /\s+/g;

/**
  * Search input or dropdown option text is sent
  * It normalizes spaces, apostrophes, accents, casing, and punctuation so search comparisons stay consistent
  * @param value Search text or option label that needs to be normalized before comparison
  * @returns {string}
**/
export const normalizeSearchTerm = (value) => {
  return `${value ?? ""}`
    .normalize("NFKD")
    .replace(COMBINING_MARKS_REGEX, "")
    .replace(APOSTROPHE_REGEX, "")
    .replace(SPECIAL_CHAR_REGEX, " ")
    .toLowerCase()
    .trim()
    .replace(WHITESPACE_REGEX, " ");
};

/**
  * Searchable value and search term are sent
  * It compares both sides after normalization and returns whether the normalized search term exists in the normalized value
  * @param value Dropdown option label or searchable text from the UI
  * @param searchTerm User entered search text from the dropdown search bar
  * @returns {boolean}
**/
export const matchesNormalizedSearch = (value, searchTerm) => {
  const normalizedValue = normalizeSearchTerm(value);
  const normalizedSearch = normalizeSearchTerm(searchTerm);

  if (!normalizedSearch) {
    return true;
  }

  return normalizedValue.includes(normalizedSearch);
};

/**
  * Searchable value and search term are sent
  * It is a shared alias used by pages that already expect a containsText helper for dropdown filtering
  * @param value Dropdown option label or searchable text from the UI
  * @param searchTerm User entered search text from the dropdown search bar
  * @returns {boolean}
**/
export const containsText = matchesNormalizedSearch;
